import React, { Component } from "react";
import { browserHistory } from "react-router"; // 引入react路由
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getCookie, setCookie, getParam } from "Utils";
import tLoginActions from "Actions/login";
import tCommonActions from "Actions/common";

class OAuth extends Component {
  componentDidMount() {
    const { loginActions, commonActions } = this.props;

    const { origin } = window.location;
    // eslint-disable-next-line no-underscore-dangle
    const accoutHost = `${window.__config.account}`;
    const common = {
      state: 123456,
      scope: "openid",
      response_type: "code",
      client_id: "js",
      redirect_uri: `${origin}/oauth`,
    };

    const jumpToAccount = (type) => {
      switch (type) {
        case 1:
          window.location.href = (() => {
            let searchStr = "";
            Object.entries(common).forEach(([key, val]) => {
              searchStr += `&${key}=${val}`;
            });
            searchStr = searchStr.replace(/^&/, "?");
            return `${accoutHost}/authorize${searchStr}`;
          })();
          break;
        case 2:
          window.location.href = `${accoutHost}/logout?post_logout_redirect_uri=${
            common.redirect_uri
          }`;
          break;

        default:
          break;
      }
    };

    const ekt_access_token = getCookie("ekt_access_token") || undefined;
    const url_code = getParam("code") || undefined;

    if (!ekt_access_token && !url_code) {
      jumpToAccount(1);
    }

    if (url_code) {
      loginActions
        .getLoginInfoByCode({
          host: accoutHost,
          code: url_code,
          redirect_uri: common.redirect_uri,
        })
        .then((resp) => {
          const { code, data } = resp.payload;
          if ([0, 200, "0", "200"].includes(code)) {
            setCookie("ekt_access_token", data.access_token, { expires: 1 });
            localStorage.setItem(
              "user",
              JSON.stringify({
                access_token: data.access_token,
                profile: {
                  vcc_id: data.vcc_id,
                  dept_id: data.dept_id,
                  user_id: data.user_id,
                  user_name: data.user_name,
                },
              })
            );
            window.location.href = common.redirect_uri;
          }
        })
        .catch(() => {
          jumpToAccount(1);
        });
    } else if (ekt_access_token) {
      console.log("有token");
      loginActions
        .checkCustomize()
        .then((res) => {
          const { data } = res.payload;
          localStorage.setItem("customize", data);
        })
        .then(() => {
          commonActions.getSideNav().then(() => {
            const { common: { menuList } = {} } = this.props;
            const selectedPath =
              menuList && menuList[0] && menuList[0].children[0]
                ? menuList[0].children[0].to
                : "/taskManage/firstPage";
            setTimeout(() => {
              browserHistory.push(selectedPath);
            }, 500);
          });
        });
    }
  }

  render() {
    return <div />;
  }
}

const mapStateToProps = (state) => {
  return {
    common: state.common,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(tCommonActions, dispatch),
    loginActions: bindActionCreators(tLoginActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OAuth);
